export default __webpack_public_path__ + "static/media/solar-panel-desktop.47548d8d.jpg";